import React from 'react'
import PT from 'prop-types'
import cx from 'classnames'
import Button from '@vimcar/shared-components/components/Button'
import Card from '@vimcar/shared-components/components/Card'
import EnhancedCheckbox from '@vimcar/shared-components/components/EnhancedCheckbox'
import Icon from '@vimcar/shared-components/components/Icon'

import colors from '#styles/colors'
import styles from './styles.css'

const IntroOption = ({
  actionText,
  caption,
  className,
  icon,
  onChangeCheckbox,
  onSubmit,
  optionChecked,
  saveOptionText,
  title,
}) => (
  <Card className={cx(className, styles.introOption)}>
    <h2 className={styles.introOptionTitle}>{title}</h2>
    <Icon
      fill={colors.colorDarkGreyLight}
      icon={icon}
      onClick={onSubmit}
      size={56}
      />
    <p className={styles.introOptionText}>
      {caption}
    </p>
    <Button
      raised
      onClick={onSubmit}
      >
      {actionText}
    </Button>
    {saveOptionText && (
      <div className={styles.introOptionSave}>
        <label className={styles.introOptionLabel}>
          <EnhancedCheckbox
            checked={optionChecked}
            className={styles.introOptionCheckbox}
            onChange={onChangeCheckbox}
            />
          {saveOptionText}
        </label>
      </div>
    )}
  </Card>
)

IntroOption.propTypes = {
  actionText: PT.string.isRequired,
  caption: PT.string.isRequired,
  className: PT.string,
  icon: PT.string.isRequired,
  onChangeCheckbox: PT.func,
  onSubmit: PT.func,
  optionChecked: PT.bool,
  saveOptionText: PT.string,
  title: PT.string.isRequired,
}

export default IntroOption
